if (!customElements.get('wlsn-article-share-button')) {
  class WLSNArticleShareButton extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        buttonMenuToggle: 'js-share-button-menu-toggle',
        buttonMenu: 'js-share-button-menu',
        buttonToggle: 'js-share-button-toggle',
      };

      this.shopUrl = window.theme.shopUrl;
    }

    get elements() {
      return {
        buttonMenuToggle: this.querySelector(`.${this.classes.buttonMenuToggle}`),
        buttonMenu: this.querySelector(`.${this.classes.buttonMenu}`),
        buttonToggle: this.querySelectorAll(`.${this.classes.buttonToggle}`),
      };
    }

    get dataAttributes() {
      return {
        buttonId: this.getAttribute('data-button-id'),
        articleUrl: this.getAttribute('data-article-url'),
        articleTitle: this.getAttribute('data-article-title'),
      };
    }

    connectedCallback() {
      this.bindEvents();
    }

    disconnectedCallback() {
      this.elements.buttonToggle.forEach((button) => {
        button.removeEventListener('click', this.shareHandler);
      });
    }

    bindEvents() {
      this.elements.buttonToggle.forEach((button) => {
        button.addEventListener('click', this.shareHandler.bind(this));
      });
    }

    shareHandler(e) {
      e.preventDefault();
      const shareOption = e.currentTarget.dataset.shareOption;
      const fullUrl = this.shopUrl + this.dataAttributes.articleUrl;
      let shareUrl;

      switch (shareOption) {
        case 'facebook':
          shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(fullUrl)}`;
          break;
        case 'twitter':
          shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(fullUrl)}`;
          break;
        case 'linkedin':
          shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(fullUrl)}`;
          break;
        case 'email':
          const emailSubject = encodeURIComponent(`Check out this article: ${this.dataAttributes.articleTitle}`);
          const emailBody = encodeURIComponent(
            `I found this article interesting and thought you might like it: \n${fullUrl}`
          );
          shareUrl = `mailto:?subject=${emailSubject}&body=${emailBody}`;
          break;
      }

      if (shareOption === 'email') {
        window.location.href = shareUrl;
      } else {
        window.open(shareUrl, '_blank', 'width=800,height=600');
      }
    }
  }

  customElements.define('wlsn-article-share-button', WLSNArticleShareButton);
}
